import axiosInstance, {
  axiosInstanceCachedV3,
  axiosInstanceCached,
  axiosInstanceV3,
  deleteCacheV3,
} from '@/utils/axios';
import { handleApiError, deleteDataCache } from '@/utils/helpers';

// function mergeArrays(...arrays) {
//   let jointArray = [];
//   arrays.forEach(array => {
//     jointArray = [...jointArray, ...array];
//   });
//   return [...new Set([...jointArray])];
// }

//* v3 ===========================================================

//* V3 Create a new user
// @ payload
// @ all user values
export const userCreate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstanceV3.post(`/user_create`, payload, { v3: true });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* V3 update a user
// @ payload
// @ all user values
export const userUpdate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/user_update_me`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ token in header
export const v3GetMe = async (payload = {}) => {
  let response = {};

  try {
    if (payload?.deleteCache) {
      await deleteDataCache(axiosInstanceCached, payload?.deleteCache, `v3_get_me`);
      // await deleteCache(axiosInstanceCached, payload?.deleteCache, 'v3_get_me');
    }
    // response = await axiosInstanceCachedV3.post(
    // `/user_get_me`,
    response = await axiosInstanceCached.post(
      `/v3/user_get_me`,
      {
        id: `v3_get_me`,
        cache: {
          ttl: 1000 * 60 * 15,
        },
      },
      payload
    );
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ user_id: "user-id"
// @ offset: number of entries to skip
// @ limit: number of entries to display
// @ {
// @ 	"user_id": "3eaef7a7-7592-45b4-9896-30175a5f9424",
// @ 	"offset": 0,
// @ 	"limit": 5
// @ }
export const v3UserFeedList = async (payload) => {
  let response = {};
  try {
    // response = await axiosInstanceV3.post(`/user_feed_list`, payload);
    response = await axiosInstance.post(`/v3/user_feed_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @  "user_id": user ID,
// @  deleteCache: default false. Set to true to delete cache and query fresh data
// @  "page_info": { Number of items to return?
// @    "limit": 5
// @  }
export const userStatsList = async (payload) => {
  let response = {};
  const { deleteCache = false, user_id: id } = payload;
  await deleteDataCache(axiosInstanceCached, deleteCache, `user_stats_list_${id}`);

  try {
    response = await axiosInstanceCached.post(`/v3/stats_user_list`, payload, {
      id: `user_stats_list_${id}`,
      cache: {
        ttl: 1000 * 60 * 30, // 30 minutes
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @  This is defaulted to all time stats 1-1-2015 to present
// @  So that it doesn't affect the other DTP stats
// @  "user_id": user ID,
// @  deleteCache: default false. Set to true to delete cache and query fresh data
// @  "page_info": { Number of items to return?
// @    "limit": 5
// @  }
export const userProfileStatsList = async (payload) => {
  let response = {};
  const { deleteCache = false, user_id: id } = payload;
  await deleteDataCache(axiosInstanceCached, deleteCache, `user_profile_stats_list_${id}`);

  try {
    response = await axiosInstanceCached.post(`/v3/stats_user_list`, payload, {
      id: `user_profile_stats_list_${id}`,
      cache: {
        ttl: 1000 * 60 * 30, // 30 minutes
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const v3CalcHandicap = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/calculate_handicap`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
